import React from "react";
import { useTranslation } from "react-i18next";

import "./styles.css";

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation("auth");
    const mainDomain = process.env.REACT_APP_STAGE === "production" ? "kp.poedinkitsm.com" : "test-kp.poedinkitsm.com";

    return (
        <div className="footer">
            <div className="footer__links">
                <div className="footer__links__group">
                    <a
                        href={`https://${mainDomain}/policy`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("footer.links.policy")}
                    </a>
                    <a
                        href={`https://${mainDomain}/cookies`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("footer.links.cookies")}
                    </a>
                </div>
                <div className="footer__links__group">
                    <a
                        href="https://ama1984.com/cc"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("footer.links.ip")}
                    </a>
                    <a
                        href="https://ama1984.com/payment"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {t("footer.links.payment")}
                    </a>
                </div>
            </div>
            <div className="footer__divider" />
            <div className="footer__copyright">© Academy of Management Art, 1984-{currentYear}</div>
        </div>
    );
};

export default Footer;
